import React, {FC} from 'react'
import { KTIcon } from '../../../helpers'
import { DefaultTitle2 } from '../header/page-title/DefaultTitle2'
import clsx from 'clsx'
import { useLayout } from '../../core'

const Toolbar2: FC = () => {
  const {classes} = useLayout()

  return (
    <>
      <div className='toolbar py-5 py-lg-15' id='kt_toolbar'>
        {/* begin::Container */}
        <div
          id='kt_toolbar_container'
          className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
        >
          {/* <DefaultTitle2 /> */}

          
        </div>
        {/* end::Container */}
      </div>
     
    </>
  )
}

export {Toolbar2}
